<template>
  <div class="col-md-4 col-sm-6 dashboard-item commissions">
    <div class="card bg">
      <div class="row p-2">
        <div class="text-primary p-3">
          <h3>REPORTS</h3>
          <date-picker class="mt-2 mb-2" v-model="dateRange" :value-type="'M/D/YY'" range lang="en" confirm @change="updateDateRange">
            <template v-slot:input>
              <h4 class="text-center">
                <i class="bx bx-calendar mr-1"></i>
                <span v-html="displayedRange"></span>
                <i v-if="dateRange.length" @click="updateWithoutDateFilter()" class="bx bx-x ml-3"></i>
                <i v-else class="bx bx-edit-alt ml-1"></i>
              </h4>
            </template>
          </date-picker>
          <b-tabs justified nav-class="nav-tabs-custom" content-class="p-1 text-muted">
            <b-tab active>
              <template v-slot:title>
                <span class="d-none d-inline-block"><h4>COMMISSIONS</h4></span>
              </template>
              <div>
                <label>Total Commissions</label>
                <h1 v-if="totals"><strong>{{ currency(totals.paid + totals.unpaid) }}</strong></h1>
              </div>
              <div v-if="commissions">
                <label>Products Sold & Purchased</label>
                <h1><strong>{{ totals.paidPayments + totals.unpaidPayments }}</strong></h1>
                <div class="commissions-data">
                  <div v-for="(commission, key) in commissions" v-bind:key="key" @click="viewCommission(commission.id)">
                    <p v-if="totals.unpaidPayments && key == 0">
                      {{ totals.unpaidPayments }} Commissions Pending
                      <span class="text-right">{{ currency(totals.unpaid) }}</span>
                    </p>
                    <p v-if="totals.paidPayments && key == totals.unpaidPayments">
                      {{ totals.paidPayments }} Commissions Paid
                      <span class="text-right">{{ currency(totals.paid) }}</span>
                    </p>
                    <thumbnail-row
                      :initials="commissionClient(commission.attributes.clientId).initials"
                      :thumbnailUrl="commissionClient(commission.attributes.clientId).thumbnailUrl"
                      :row-main="commission.attributes.productName"
                      :extra-content="currency(commission.attributes.amount)"
                      :action-icon="true">
                    </thumbnail-row>
                  </div>
                </div>
                <div v-if="paginatedRemaining">
                  <button class="btn btn-outline-light mt-5" @click="getCommissions(true)">View Next {{ paginatedRemaining }}</button>
                </div>
              </div>
              <div v-else>
                <p class="text-white"></p>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-none d-inline-block"><h4>CLIENTS</h4></span>
              </template>
              <div v-for="(client, key) in commissionClients" v-bind:key="key" @click="viewClient(client[0].id)">
                <thumbnail-row
                  :initials="commissionClient(client[0].id).initials"
                  :thumbnailUrl="commissionClient(client[0].id).thumbnailUrl"
                  :row-main="commissionClient(client[0].id).firstName"
                  :extra-content="currency(client[0].amount)"
                  :action-icon="true">
                </thumbnail-row>
              </div>
              <b-modal
                id="client-modal"
                scrollable
                title-class="font-18"
                header-class="d-none"
                footer-class="d-none"
              >
                <client-detail :clientId="viewedClientId"></client-detail>
              </b-modal>
            </b-tab>
          </b-tabs>
          <b-modal
            id="commission-modal"
            scrollable
            header-class="d-none"
            footer-class="d-none">
            <commission :commissionId="activeCommissionId"></commission>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api'
import ThumbnailRow from '../components/shared/thumbnail-row'
import DatePicker from 'vue2-datepicker'
import ClientDetail from '../components/client-detail'
import 'vue2-datepicker/index.css'
import Commission from './commission'

export default {
  name: 'commissions',
  components: { Commission, ThumbnailRow, DatePicker, ClientDetail },
  data () {
    return {
      displayedRange: '',
      dateRange: '',
      commissions: [],
      activeCommissionId: '',
      viewedClientId: '',
      commissionClients: {},
      totals: {},
      paginatedRemaining: '',
      commissionData: {}
    }
  },
  methods: {
    getCommissions (paginated = false) {
      return api.get(this.commissionsUrl, {
        params: {
          startDate: this.dateRange ? this.dateRange[0] : '',
          endDate: this.dateRange ? this.dateRange[1] : ''
        }
      }).then(response => {
        this.commissionData = response.data
        if (paginated) {
          this.commissions.push(...this.commissionData.data)
        } else {
          this.commissions = this.commissionData.data
        }
        this.totals = this.commissionData.meta
        this.checkPagination()
        this.parseClients()
        this.$emit('commissionsUpdated', this.totals.timelineData)
      })
    },
    currency (amount) {
      return this.$helpers.currency(amount)
    },
    updateDateRange () {
      if (!this.dateRange[0]) {
        return
      }
      this.displayedRange = this.dateRange[0] + ' <i class="bx bx-chevron-right"></i> ' + this.dateRange[1]
      this.getCommissions()
    },
    updateWithoutDateFilter () {
      this.dateRange = ''
      this.displayedRange = 'All Time'
      this.getCommissions()
    },
    viewCommission (commissionId) {
      this.activeCommissionId = commissionId
      this.$bvModal.show('commission-modal')
    },
    viewClient (clientId) {
      this.viewedClientId = clientId
      this.$bvModal.show('client-modal')
    },
    commissionClient (clientId) {
      return this.clients.find(client => client.id === clientId)
    },
    parseClients () {
      if (!this.commissions) {
        return
      }
      this.commissions.forEach(commission => {
        const commissionAmount = commission.attributes.amount
        const clientId = commission.attributes.clientId
        if (!this.commissionClients[clientId]) {
          this.commissionClients[clientId] = [{
            id: commission.attributes.clientId,
            amount: 0
          }]
        }
        this.commissionClients[clientId][0].amount += commissionAmount
      })
    },
    checkPagination () {
      const pagination = this.commissionData.meta.pagination
      if (pagination.total > this.commissions.length) {
        const remainingCommissions = pagination.total - this.commissions.length
        this.paginatedRemaining = remainingCommissions > pagination.per_page ? pagination.per_page : remainingCommissions
      } else {
        this.paginatedRemaining = ''
      }
    }
  },
  mounted () {
    this.updateWithoutDateFilter()
  },
  computed: {
    clients () {
      return this.$store.state.clients
    },
    commissionsUrl () {
      if (this.commissionData.links && this.commissionData.links.next) {
        return this.commissionData.links.next
      }
      return process.env.VUE_APP_FASHIONPHILE_API_URL + '/api/stylist/commissions'
    }
  }
}
</script>

<style>
  .commissions-data {
    max-height: 400px;
    overflow: auto;
  }
  .commissions i.bx-x {
    font-size: 24px;
  }
  .commissions .thumbnail-row-container {
    border-top: 1px #666 solid;
    text-transform: capitalize;
    min-width: 100%;
  }
  .mx-datepicker-range {
    width: 100%;
    cursor: pointer;
  }
  .mx-datepicker-range:hover {
    color: #FF0099;
  }
  .mx-datepicker i.mx-icon-calendar, .mx-datepicker i.mx-icon-clear {
    display: none !important;
  }
  .nav-tabs-custom li a.nav-link.active {
    background: transparent;
  }
  .commissions .tabs{
    width:100%;
  }
</style>
